import React from 'react';
import { useAppelAbsences } from '@teetsh/app/src/queries/appels/useAppelsAbsences';
import { ElevesAbsencesList } from './ElevesAbsencesList';

interface Props {
  from: Date;
  to: Date;
  eleveId: string;
}

export function ElevesAbsencesListWithData(props: Props) {
  const { from, to, eleveId } = props;
  const { data: eleveAbsences } = useAppelAbsences({ from, to, eleveId });

  if (!eleveAbsences || eleveAbsences?.eleves.length === 0) {
    return null;
  }

  return <ElevesAbsencesList eleve={eleveAbsences?.eleves[0]} />;
}
